/*

https://github.com/themesberg/flowbite-icons

Flowbite Icons is free and open-source under the MIT License.

*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function Copy({
    className = null,
}: Props) {
    return (
        <svg className={className} width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4232 0.5H8.333C7.74894 0.5 7.19914 0.7184 6.78644 1.1153L4.72435 3.0949C4.31091 3.4911 4.08341 4.0189 4.08341 4.5803V10.3C4.08341 11.0721 4.7156 11.7 5.49362 11.7H11.4239C12.2012 11.7 12.8334 11.0721 12.8334 10.3V1.9C12.8334 1.1279 12.2012 0.5 11.4232 0.5ZM7.72925 2.1898V4H5.84362L7.72925 2.1898ZM5.54175 10.3V5.4H7.72925C8.53352 5.4 9.18758 4.7721 9.18758 4V1.8951L11.3707 1.8818C11.3707 1.8818 11.3751 1.8874 11.3751 1.9L11.4232 10.3H5.54175Z" />
            <path d="M8.45841 12.4V13.1H2.62508L2.62435 4.7H3.35425V3.3H2.62508C1.82081 3.3 1.16675 3.9279 1.16675 4.7V13.1C1.16675 13.8721 1.79894 14.5 2.57696 14.5H8.48321C8.88133 14.5 9.25393 14.3488 9.53102 14.0737C9.79425 13.8126 9.90289 13.4745 9.9131 13.1L9.91675 12.4H8.45841Z" />
        </svg>
    );
}
